// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const BindPropertyResident = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        resident: null

    }),

    /*
	**  Methods
    */
    
    methods: {

        bindPropertyResidentHandler: function(resident_id) {

            try {

                this.$bind('resident', propertiesModel.doc(this.$route.params.id).collection('residents').doc(resident_id))
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Bind to the Property Resident from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Resident',
                        uid: '8Y5k24Euse4jwhqfPTaT',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Bind to a Property Resident from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Resident',
                    uid: '6gP9BFMC2VWnWdblCCkA',
                    error: e
                });

            }

        }

    }

}